import React, { useState, useRef, useEffect } from 'react'
import Navbar from '../Component/Navbar'
import axiosInstance from '../Api/axiosInstance'
import { toast } from "react-toastify";

// ── API CONSTANTS ─────────────────────────────────────────────
const API = {
  checkAccount: '/auth/enterprise-admin/check-account',
  sendOtp: '/auth/enterprise-admin/send-otp',
  login: '/auth/enterprise-admin/login',
  setupMpin: '/auth/enterprise-admin/setup-mpin',
  resetMpin: '/auth/enterprise-admin/reset-mpin',
}

// ── STYLES ────────────────────────────────────────────────────
const s = {
  body: {
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    background: '#F5F4E8',
    fontFamily: "'DM Sans', sans-serif",
  },
  main: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 16px',
  },
  card: {
    background: '#fff',
    borderRadius: '28px',
    padding: '52px 44px 44px',
    width: '100%',
    maxWidth: '420px',
    boxShadow: '0 8px 40px rgba(59,61,26,0.10), 0 2px 8px rgba(59,61,26,0.06)',
    position: 'relative',
  },
  topBar: {
    position: 'absolute',
    top: 0, left: '44px', right: '44px',
    height: '3px',
    background: 'linear-gradient(90deg, #6B6F2A, #B5BC4A, #6B6F2A)',
    borderRadius: '0 0 4px 4px',
  },
  h1: {
    fontFamily: 'Georgia, serif',
    fontSize: '2rem',
    fontWeight: '700',
    color: '#3B3D1A',
    textAlign: 'center',
    letterSpacing: '-0.5px',
    marginBottom: '6px',
  },
  subtitle: {
    textAlign: 'center',
    fontSize: '0.9rem',
    color: '#7A7C50',
    fontWeight: '300',
    marginBottom: '28px',
  },
  label: {
    display: 'block',
    fontSize: '0.78rem',
    fontWeight: '600',
    color: '#6B6F2A',
    marginBottom: '6px',
    letterSpacing: '0.3px',
    textTransform: 'uppercase',
  },
  inputWrapper: { position: 'relative', marginBottom: '16px' },
  prefix: {
    position: 'absolute',
    left: '16px', top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex', alignItems: 'center', gap: '6px',
    fontSize: '0.9rem',
    color: '#6B6F2A',
    fontWeight: '500',
    pointerEvents: 'none',
  },
  prefixDiv: { width: '1px', height: '18px', background: '#E8ECBF', marginLeft: '4px' },
  input: {
    width: '100%',
    padding: '15px 16px',
    border: '1.5px solid #E8ECBF',
    borderRadius: '14px',
    fontSize: '1rem',
    fontFamily: "'DM Sans', sans-serif",
    color: '#1E1F0C',
    background: '#F5F4E8',
    outline: 'none',
    letterSpacing: '0.5px',
    boxSizing: 'border-box',
    transition: 'border-color 0.2s, box-shadow 0.2s',
  },
  inputPhone: { paddingLeft: '80px' },
  hint: {
    fontSize: '0.78rem',
    color: '#7A7C50',
    marginBottom: '20px',
    paddingLeft: '2px',
    display: 'flex', alignItems: 'center', gap: '5px',
  },
  errorHint: { color: '#c0392b' },
  btn: {
    width: '100%',
    padding: '17px',
    background: 'linear-gradient(135deg, #6B6F2A 0%, #8B9428 60%, #B5BC4A 100%)',
    color: '#fff',
    border: 'none',
    borderRadius: '14px',
    fontSize: '1rem',
    fontWeight: '600',
    fontFamily: "'DM Sans', sans-serif",
    letterSpacing: '0.5px',
    cursor: 'pointer',
    boxShadow: '0 4px 20px rgba(107,111,42,0.35)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    transition: 'opacity 0.2s, transform 0.15s',
    marginBottom: '12px',
  },
  btnOutline: {
    width: '100%',
    padding: '15px',
    background: 'transparent',
    color: '#6B6F2A',
    border: '1.5px solid #B5BC4A',
    borderRadius: '14px',
    fontSize: '1rem',
    fontWeight: '600',
    fontFamily: "'DM Sans', sans-serif",
    letterSpacing: '0.5px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    transition: 'background 0.2s, border-color 0.2s',
    marginBottom: '12px',
  },
  btnDisabled: { opacity: 0.65, cursor: 'not-allowed' },
  footer: {
    textAlign: 'center',
    fontSize: '0.75rem',
    color: '#BBBF8A',
    marginTop: '20px',
  },
  link: { color: '#8B9428', textDecoration: 'none', fontWeight: '500' },
  backBtn: {
    background: 'none',
    border: 'none',
    color: '#6B6F2A',
    fontSize: '0.85rem',
    fontWeight: '600',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    marginBottom: '20px',
    padding: 0,
    fontFamily: "'DM Sans', sans-serif",
  },
  otpRow: {
    display: 'flex',
    gap: '8px',
    marginBottom: '8px',
    justifyContent: 'center',
  },
  otpBox: {
    width: '44px', height: '52px',
    border: '1.5px solid #E8ECBF',
    borderRadius: '12px',
    fontSize: '1.4rem',
    fontWeight: '700',
    textAlign: 'center',
    background: '#F5F4E8',
    color: '#3B3D1A',
    outline: 'none',
    fontFamily: "'DM Sans', sans-serif",
    transition: 'border-color 0.2s, box-shadow 0.2s',
  },
  mpinRow: {
    display: 'flex',
    gap: '12px',
    marginBottom: '8px',
    justifyContent: 'center',
  },
  mpinBox: {
    width: '56px', height: '64px',
    border: '1.5px solid #E8ECBF',
    borderRadius: '14px',
    fontSize: '1.6rem',
    fontWeight: '700',
    textAlign: 'center',
    background: '#F5F4E8',
    color: '#3B3D1A',
    outline: 'none',
    fontFamily: "'DM Sans', sans-serif",
    transition: 'border-color 0.2s, box-shadow 0.2s',
    letterSpacing: '0.5px',
  },
  resend: {
    textAlign: 'center',
    fontSize: '0.82rem',
    color: '#7A7C50',
    marginBottom: '20px',
  },
  resendBtn: {
    background: 'none',
    border: 'none',
    color: '#8B9428',
    fontWeight: '600',
    cursor: 'pointer',
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '0.82rem',
    padding: 0,
  },
  errorBox: {
    background: '#FEF2F2',
    border: '1px solid #FECACA',
    borderRadius: '12px',
    padding: '12px 16px',
    marginBottom: '14px',
    fontSize: '0.85rem',
    color: '#c0392b',
    fontWeight: '500',
  },
  infoBox: {
    background: '#EEF4DC',
    border: '1px solid #B5BC4A',
    borderRadius: '12px',
    padding: '12px 16px',
    marginBottom: '14px',
    fontSize: '0.85rem',
    color: '#3B3D1A',
    fontWeight: '500',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  stepIndicator: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    marginBottom: '24px',
  },
  stepDot: {
    width: '8px', height: '8px',
    borderRadius: '50%',
    background: '#E8ECBF',
    transition: 'all 0.3s',
  },
  stepDotActive: { background: '#6B6F2A', width: '24px', borderRadius: '4px' },
  stepDotDone: { background: '#B5BC4A' },
  sectionLabel: {
    fontSize: '0.82rem',
    fontWeight: '600',
    color: '#7A7C50',
    marginBottom: '8px',
    marginTop: '4px',
    letterSpacing: '0.2px',
  },
  forgotBtn: {
    background: 'none',
    border: 'none',
    color: '#8B9428',
    fontWeight: '600',
    cursor: 'pointer',
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '0.85rem',
    padding: 0,
    textAlign: 'right',
    width: '100%',
    marginBottom: '20px',
    marginTop: '-4px',
  },
  divider: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '16px',
    color: '#BBBF8A',
    fontSize: '0.78rem',
  },
  dividerLine: { flex: 1, height: '1px', background: '#E8ECBF' },
  termsRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    marginBottom: '20px',
    fontSize: '0.82rem',
    color: '#7A7C50',
  },
  checkbox: {
    width: '18px', height: '18px',
    accentColor: '#6B6F2A',
    cursor: 'pointer',
    flexShrink: 0,
    marginTop: '1px',
  },
}

const globalCSS = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { -webkit-font-smoothing: antialiased; }

  .nav {
    height: 64px;
    display: flex; align-items: center; justify-content: space-between;
    padding: 0 60px;
    background: #fff;
    border-bottom: 1px solid #E8ECBF;
    position: sticky; top: 0; z-index: 200;
    box-shadow: 0 2px 12px rgba(59,61,26,0.06);
  }
  .nav-brand { display: flex; align-items: center; cursor: pointer; }
  .nav-brand img { width: 220px; height: auto; object-fit: contain; }

  .otp-input:focus { border-color: #8B9428 !important; box-shadow: 0 0 0 3px rgba(139,148,40,0.15) !important; }
  .mpin-input:focus { border-color: #8B9428 !important; box-shadow: 0 0 0 3px rgba(139,148,40,0.15) !important; }
  .phone-input:focus { border-color: #8B9428 !important; box-shadow: 0 0 0 3px rgba(139,148,40,0.15) !important; }
  .btn-outline:hover { background: #F5F4E8 !important; }

  @keyframes slideIn { from { opacity:0; transform:translateY(10px); } to { opacity:1; transform:translateY(0); } }
  .slide-in { animation: slideIn 0.3s ease both; }

  @keyframes spin { to { transform: rotate(360deg); } }
  .spin-svg { animation: spin 0.7s linear infinite; transform-origin: center; }

  @keyframes popIn {
    0% { opacity: 0; transform: scale(0.5); }
    70% { transform: scale(1.1); }
    100% { opacity: 1; transform: scale(1); }
  }
  .pop-in { animation: popIn 0.5s cubic-bezier(0.34,1.56,0.64,1) both; }

  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(14px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .fade-up-1 { animation: fadeUp 0.4s ease 0.15s both; }
  .fade-up-2 { animation: fadeUp 0.4s ease 0.3s both; }
  .fade-up-3 { animation: fadeUp 0.4s ease 0.45s both; }

  @keyframes shimmer {
    0%   { background-position: -200% center; }
    100% { background-position: 200% center; }
  }

  @media (max-width: 640px) {
    .nav { padding: 0 20px; }
    .nav-links { display: none; }
  }
`

// ── SHARED COMPONENTS ─────────────────────────────────────────
const ArrowIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="rgba(255,255,255,0.85)">
    <path d="M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z" />
  </svg>
)

const InfoIcon = ({ color }) => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill={color} style={{ flexShrink: 0 }}>
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
  </svg>
)

const Spinner = ({ size = 20, color = 'white' }) => (
  <svg className="spin-svg" width={size} height={size} viewBox="0 0 24 24"
    fill="none" stroke={color} strokeWidth="2.5" strokeLinecap="round">
    <circle cx="12" cy="12" r="10" strokeDasharray="40 20" />
  </svg>
)

const BackButton = ({ onClick, disabled, label = 'Back' }) => (
  <button style={s.backBtn} onClick={onClick} disabled={disabled}>
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#6B6F2A"
      strokeWidth="2.5" strokeLinecap="round"><path d="M19 12H5M12 5l-7 7 7 7" /></svg>
    {label}
  </button>
)

// OTP 6-digit row
const OtpInputRow = ({ value, onChange, disabled, error, inputRef }) => {
  const refs = useRef([])

  const handleChange = (i, val) => {
    if (!/^\d*$/.test(val)) return
    const next = [...value]
    next[i] = val.slice(-1)
    onChange(next)
    if (val && i < 5) refs.current[i + 1]?.focus()
  }

  const handleKeyDown = (i, e) => {
    if (e.key === 'Backspace' && !value[i] && i > 0) refs.current[i - 1]?.focus()
  }

  const handlePaste = (e) => {
    const pasted = e.clipboardData.getData('text').replace(/\D/g, '').slice(0, 6)
    if (pasted.length === 6) { onChange(pasted.split('')); refs.current[5]?.focus() }
  }

  useEffect(() => {
    if (inputRef) inputRef.current = refs.current[0]
  }, [])

  return (
    <div style={s.otpRow} onPaste={handlePaste}>
      {value.map((digit, i) => (
        <input
          key={i}
          className="otp-input"
          ref={el => { refs.current[i] = el }}
          type="tel"
          maxLength={1}
          value={digit}
          disabled={disabled}
          onChange={e => handleChange(i, e.target.value)}
          onKeyDown={e => handleKeyDown(i, e)}
          style={{
            ...s.otpBox,
            borderColor: error ? '#c0392b' : digit ? '#8B9428' : '#E8ECBF',
            boxShadow: digit ? '0 0 0 3px rgba(139,148,40,0.10)' : 'none',
            opacity: disabled ? 0.6 : 1,
          }}
        />
      ))}
    </div>
  )
}

// MPIN 4-digit row
const MpinInputRow = ({ value, onChange, disabled, error, masked = true }) => {
  const refs = useRef([])

  const handleChange = (i, val) => {
    if (!/^\d*$/.test(val)) return
    const next = [...value]
    next[i] = val.slice(-1)
    onChange(next)
    if (val && i < 3) refs.current[i + 1]?.focus()
  }

  const handleKeyDown = (i, e) => {
    if (e.key === 'Backspace' && !value[i] && i > 0) refs.current[i - 1]?.focus()
  }

  return (
    <div style={s.mpinRow}>
      {value.map((digit, i) => (
        <input
          key={i}
          className="mpin-input"
          ref={el => { refs.current[i] = el }}
          type={masked ? 'password' : 'tel'}
          maxLength={1}
          value={digit}
          disabled={disabled}
          onChange={e => handleChange(i, e.target.value)}
          onKeyDown={e => handleKeyDown(i, e)}
          style={{
            ...s.mpinBox,
            borderColor: error ? '#c0392b' : digit ? '#8B9428' : '#E8ECBF',
            boxShadow: digit ? '0 0 0 3px rgba(139,148,40,0.10)' : 'none',
            opacity: disabled ? 0.6 : 1,
          }}
        />
      ))}
    </div>
  )
}

// Resend timer
const ResendTimer = ({ onResend, loading }) => {
  const [timer, setTimer] = useState(30)
  useEffect(() => {
    const id = setInterval(() => setTimer(t => (t > 0 ? t - 1 : 0)), 1000)
    return () => clearInterval(id)
  }, [])

  const handleResend = () => { onResend(); setTimer(30) }

  return (
    <div style={s.resend}>
      {timer > 0
        ? <span>Resend OTP in <strong style={{ color: '#6B6F2A' }}>0:{String(timer).padStart(2, '0')}</strong></span>
        : <span>Didn't receive OTP?{' '}
          <button style={s.resendBtn} onClick={handleResend} disabled={loading}>
            {loading ? 'Sending…' : 'Resend'}
          </button>
        </span>
      }
    </div>
  )
}

// ── STEP 1: PHONE CHECK ───────────────────────────────────────
const PhoneStep = ({ onAccountChecked }) => {
  const [phone, setPhone] = useState('')
  const [agreed, setAgreed] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleContinue = async () => {
    if (phone.length !== 10) { setError('Please enter a valid 10-digit number'); return }
    if (!agreed) { setError('Please agree to the terms & conditions'); return }
    setError('')
    setLoading(true)
    try {
      const res = await axiosInstance.post(API.checkAccount, { phoneNumber: phone })
      const data = res.data
      if (!data.success) {
        setError(data?.message || 'Number not registered. Please contact your administrator.')
        return
      }
      onAccountChecked({
        phone,
        emailId: data.data?.emailId,
        isMPINSetupRequired: data.data?.isMPINSetupRequired,
      })
    } catch (err) {
      const msg = err?.response?.data?.message
      setError(msg || 'Network error. Please check your connection.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="slide-in">
      <div style={s.inputWrapper}>
        <label style={s.label}>Mobile Number</label>
        <div style={{ position: 'relative' }}>
          <span style={s.prefix}>
            🇮🇳 +91 <span style={s.prefixDiv} />
          </span>
          <input
            className="phone-input"
            type="tel"
            placeholder="Mobile"
            value={phone}
            maxLength={10}
            onChange={e => { setPhone(e.target.value.replace(/\D/g, '').slice(0, 10)); setError('') }}
            onKeyDown={e => e.key === 'Enter' && !loading && handleContinue()}
            style={{
              ...s.input, ...s.inputPhone,
              borderColor: error && !agreed ? '#c0392b' : '#E8ECBF',
            }}
          />
        </div>
      </div>

      <div style={s.termsRow}>
        <input
          type="checkbox"
          style={s.checkbox}
          checked={agreed}
          onChange={e => { setAgreed(e.target.checked); setError('') }}
          id="terms"
        />
        <label htmlFor="terms" style={{ cursor: 'pointer', lineHeight: '1.4' }}>
          I agree to the{' '}
          <a href="#" style={s.link}>terms &amp; conditions</a>
        </label>
      </div>

      {error && (
        <p style={{ ...s.hint, ...s.errorHint, marginBottom: '16px' }}>
          <InfoIcon color="#c0392b" /> {error}
        </p>
      )}

      <button
        style={{ ...s.btn, ...(loading || !phone ? s.btnDisabled : {}) }}
        onClick={handleContinue}
        disabled={loading || !phone}
      >
        {loading ? <><Spinner /> Checking…</> : <>Continue <ArrowIcon /></>}
      </button>
    </div>
  )
}

// ── STEP 2A: MPIN LOGIN ────────────────────────────────────────
const MpinLoginStep = ({ phone, onSuccess, onBack, onSwitchToOtp, onForgotMpin }) => {
  const [mpin, setMpin] = useState(['', '', '', ''])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [otpLoading, setOtpLoading] = useState(false)
  const [forgotLoading, setForgotLoading] = useState(false)

  const handleLogin = async () => {
    if (mpin.join('').length !== 4) {
      setError('Please enter your 4-digit MPIN')
      return
    }
    setError('')
    setLoading(true)
    try {
      const payload = {
        phoneNumber: phone,
        loginType: 'MPIN',
        mpin: mpin.join(''),
      }
      const res = await axiosInstance.post(API.login, payload)
      const data = res.data
      if (!data?.success) {
        setError(data?.message || 'Invalid MPIN. Please try again.')
        return
      }
      persistAuth(data.data || data)
      onSuccess(data, 'login')
      toast.success("Login successful")
    } catch (err) {
      setError(
        err?.response?.data?.message ||
        'Network error. Please check your connection.'
      )
    } finally {
      setLoading(false)
    }
  }

  const handleSwitchToOtp = async () => {
    setOtpLoading(true)
    setError('')
    try {
      const res = await axiosInstance.post(API.sendOtp, {
        phoneNumber: phone,
        type: 'LOGIN',
      })
      const data = res.data
      if (!data?.success) {
        setError(data?.message || 'Failed to send OTP.')
        return
      }
      onSwitchToOtp()
    } catch (err) {
      setError(
        err?.response?.data?.message ||
        'Failed to send OTP. Please try again.'
      )
    } finally {
      setOtpLoading(false)
    }
  }

  const handleForgotMpin = async () => {
    setForgotLoading(true)
    setError('')
    try {
      const res = await axiosInstance.post(API.sendOtp, {
        phoneNumber: phone,
        type: 'FORGOT_MPIN',
      })
      const data = res.data
      if (!data?.success) {
        setError(data?.message || 'Failed to send OTP.')
        return
      }
      onForgotMpin()
    } catch (err) {
      setError(
        err?.response?.data?.message ||
        'Failed to send OTP. Please try again.'
      )
    } finally {
      setForgotLoading(false)
    }
  }

  const filled = mpin.join('').length === 4

  return (
    <div className="slide-in">
      {/* <BackButton onClick={onBack} disabled={loading || otpLoading || forgotLoading} label="Change number" /> */}

      <div style={s.infoBox}>
        <InfoIcon color="#6B6F2A" />
        <span>Signing in as <strong>+91 {phone}</strong></span>
      </div>

      <div style={{ marginBottom: '4px' }}>
        <label style={s.label}>MPIN</label>
        <MpinInputRow value={mpin} onChange={setMpin} disabled={loading} error={!!error} />
      </div>

      <button
        style={{ ...s.forgotBtn, ...(forgotLoading || loading || otpLoading ? s.btnDisabled : {}) }}
        onClick={handleForgotMpin}
        disabled={forgotLoading || loading || otpLoading}
      >
        {forgotLoading ? 'Sending OTP…' : 'Forgot MPIN?'}
      </button>

      {error && <div style={s.errorBox}>{error}</div>}

      <button
        style={{ ...s.btn, ...(!filled || loading ? s.btnDisabled : {}) }}
        onClick={handleLogin}
        disabled={!filled || loading}
      >
        {loading ? <><Spinner /> Logging in…</> : <>Login <ArrowIcon /></>}
      </button>

      <div style={s.divider}>
        <div style={s.dividerLine} /> or <div style={s.dividerLine} />
      </div>

      <button
        className="btn-outline"
        style={{ ...s.btnOutline, ...(otpLoading ? s.btnDisabled : {}) }}
        onClick={handleSwitchToOtp}
        disabled={otpLoading || loading || forgotLoading}
      >
        {otpLoading ? <><Spinner size={18} color="#6B6F2A" /> Sending OTP…</> : 'Log In with OTP'}
      </button>
    </div>
  )
}

// ── STEP 2B: OTP LOGIN ─────────────────────────────────────────
const OtpLoginStep = ({ phone, emailId, onSuccess, onBack }) => {
  const [emailOtp, setEmailOtp] = useState(['', '', '', '', '', ''])
  const [phoneOtp, setPhoneOtp] = useState(['', '', '', '', '', ''])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [resendLoading, setResendLoading] = useState(false)

  const handleVerify = async () => {
    const eOtp = emailOtp.join('')
    const pOtp = phoneOtp.join('')
    if (eOtp.length !== 6 || pOtp.length !== 6) {
      setError('Please enter both 6-digit OTPs')
      return
    }
    setError('')
    setLoading(true)
    try {
      const payload = {
        phoneNumber: phone,
        loginType: 'OTP',
        mobileOTP: pOtp,
        emailOTP: eOtp,
      }
      const res = await axiosInstance.post(API.login, payload)
      const data = res.data
      if (!data?.success) {
        setError(data?.message || 'Invalid OTP. Please try again.')
        return
      }
      persistAuth(data.data || data)
      onSuccess(data, 'login')
    } catch (err) {
      setError(
        err?.response?.data?.message ||
        'Network error. Please check your connection.'
      )
    } finally {
      setLoading(false)
    }
  }

  const handleResend = async () => {
    setResendLoading(true)
    setError('')
    try {
      await axiosInstance.post(API.sendOtp, {
        phoneNumber: phone,
        type: 'LOGIN',
      })
      setEmailOtp(['', '', '', '', '', ''])
      setPhoneOtp(['', '', '', '', '', ''])
    } catch (err) {
      setError(
        err?.response?.data?.message ||
        'Failed to resend OTP.'
      )
    } finally {
      setResendLoading(false)
    }
  }

  const filled = emailOtp.join('').length === 6 && phoneOtp.join('').length === 6

  return (
    <div className="slide-in">
      {/* <BackButton onClick={onBack} disabled={loading} label="Back to MPIN" /> */}

      <p style={{ ...s.subtitle, marginBottom: '20px' }}>
        An OTP has been sent to <strong style={{ color: '#3B3D1A' }}>{emailId}</strong>{' '}
        &amp; <strong style={{ color: '#3B3D1A' }}>+91 {phone}</strong>
      </p>

      <div style={{ marginBottom: '4px' }}>
        <p style={s.sectionLabel}>Enter Email OTP</p>
        <OtpInputRow value={emailOtp} onChange={setEmailOtp} disabled={loading} error={!!error} />
      </div>

      <div style={{ marginBottom: '12px' }}>
        <p style={s.sectionLabel}>Enter Phone OTP</p>
        <OtpInputRow value={phoneOtp} onChange={setPhoneOtp} disabled={loading} error={!!error} />
      </div>

      {error && <div style={s.errorBox}>{error}</div>}

      <ResendTimer onResend={handleResend} loading={resendLoading} />

      <button
        style={{ ...s.btn, ...(!filled || loading ? s.btnDisabled : {}) }}
        onClick={handleVerify}
        disabled={!filled || loading}
      >
        {loading ? <><Spinner /> Verifying…</> : <>Verify &amp; Login <ArrowIcon /></>}
      </button>
    </div>
  )
}

// ── STEP 3: SET MPIN (new user) ────────────────────────────────
const SetMpinStep = ({ phone, emailId, onSuccess, onBack }) => {
  const [emailOtp, setEmailOtp] = useState(['', '', '', '', '', ''])
  const [phoneOtp, setPhoneOtp] = useState(['', '', '', '', '', ''])
  const [mpin, setMpin] = useState(['', '', '', ''])
  const [confirmMpin, setConfirmMpin] = useState(['', '', '', ''])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [resendLoading, setResendLoading] = useState(false)

  const handleUpdate = async () => {
    const eOtp = emailOtp.join('')
    const pOtp = phoneOtp.join('')
    const mpinVal = mpin.join('')
    const confirmVal = confirmMpin.join('')

    if (eOtp.length !== 6 || pOtp.length !== 6) {
      setError('Please enter both 6-digit OTPs')
      return
    }
    if (mpinVal.length !== 4) {
      setError('Please enter a 4-digit MPIN')
      return
    }
    if (mpinVal !== confirmVal) {
      setError('MPINs do not match')
      return
    }

    setError('')
    setLoading(true)
    try {
      const payload = {
        phoneNumber: phone,
        mobileOTP: pOtp,
        emailOTP: eOtp,
        mpin: mpinVal,
      }
      const res = await axiosInstance.post(API.setupMpin, payload)
      const data = res.data
      if (!data?.success) {
        setError(data?.message || 'Setup failed.')
        return
      }
      persistAuth(data.data || data)
      onSuccess(data, 'setupMpin')
    } catch (err) {
      setError(
        err?.response?.data?.message ||
        'Network error. Please check your connection.'
      )
    } finally {
      setLoading(false)
    }
  }

  const handleResend = async () => {
    setResendLoading(true)
    try {
      await axiosInstance.post(API.sendOtp, {
        phoneNumber: phone,
        type: 'SETUP_MPIN',
      })
      setEmailOtp(['', '', '', '', '', ''])
      setPhoneOtp(['', '', '', '', '', ''])
    } catch {
      setError('Failed to resend OTP.')
    } finally {
      setResendLoading(false)
    }
  }

  const filled =
    emailOtp.join('').length === 6 &&
    phoneOtp.join('').length === 6 &&
    mpin.join('').length === 4 &&
    confirmMpin.join('').length === 4

  return (
    <div className="slide-in">
      {/* <BackButton onClick={onBack} disabled={loading} label="Change number" /> */}

      <p style={{ ...s.subtitle, marginBottom: '20px' }}>
        An OTP has been sent to <strong style={{ color: '#3B3D1A' }}>{emailId}</strong>{' '}
        &amp; <strong style={{ color: '#3B3D1A' }}>+91 {phone}</strong>
      </p>

      <div style={{ marginBottom: '4px' }}>
        <p style={s.sectionLabel}>Enter Email OTP</p>
        <OtpInputRow value={emailOtp} onChange={setEmailOtp} disabled={loading} error={!!error} />
      </div>

      <div style={{ marginBottom: '16px' }}>
        <p style={s.sectionLabel}>Enter Phone OTP</p>
        <OtpInputRow value={phoneOtp} onChange={setPhoneOtp} disabled={loading} error={!!error} />
      </div>

      <ResendTimer onResend={handleResend} loading={resendLoading} />

      <div style={{ marginBottom: '4px' }}>
        <p style={s.sectionLabel}>Enter MPIN</p>
        <MpinInputRow value={mpin} onChange={setMpin} disabled={loading} error={!!error} />
      </div>

      <div style={{ marginBottom: '16px' }}>
        <p style={s.sectionLabel}>Confirm MPIN</p>
        <MpinInputRow value={confirmMpin} onChange={setConfirmMpin} disabled={loading}
          error={!!error && mpin.join('') !== confirmMpin.join('')} />
      </div>

      {error && <div style={s.errorBox}>{error}</div>}

      <button
        style={{ ...s.btn, ...(!filled || loading ? s.btnDisabled : {}) }}
        onClick={handleUpdate}
        disabled={!filled || loading}
      >
        {loading ? <><Spinner /> Setting up…</> : <>Update <ArrowIcon /></>}
      </button>
    </div>
  )
}

// ── STEP 4: FORGOT MPIN ────────────────────────────────────────
const ForgotMpinStep = ({ phone, emailId, onSuccess, onBack }) => {
  const [emailOtp, setEmailOtp] = useState(['', '', '', '', '', ''])
  const [phoneOtp, setPhoneOtp] = useState(['', '', '', '', '', ''])
  const [mpin, setMpin] = useState(['', '', '', ''])
  const [confirmMpin, setConfirmMpin] = useState(['', '', '', ''])
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [resendLoading, setResendLoading] = useState(false)

  const handleReset = async () => {
    const eOtp = emailOtp.join('')
    const pOtp = phoneOtp.join('')
    const mpinVal = mpin.join('')
    const confirmVal = confirmMpin.join('')

    if (eOtp.length !== 6 || pOtp.length !== 6) {
      setError('Please enter both 6-digit OTPs')
      return
    }
    if (mpinVal.length !== 4) {
      setError('Please enter a 4-digit MPIN')
      return
    }
    if (mpinVal !== confirmVal) {
      setError('MPINs do not match')
      return
    }

    setError('')
    setLoading(true)
    try {
      const payload = {
        phoneNumber: phone,
        mobileOTP: pOtp,
        emailOTP: eOtp,
        mpin: mpinVal,
        confirmMPIN: confirmVal,
      }
      const res = await axiosInstance.post(API.resetMpin, payload)
      const data = res.data
      if (!data?.success) {
        setError(data?.message || 'Reset failed. Please try again.')
        return
      }
      persistAuth(data.data || data)
      onSuccess(data, 'forgotMpin')
    } catch (err) {
      setError(
        err?.response?.data?.message ||
        'Network error. Please check your connection.'
      )
    } finally {
      setLoading(false)
    }
  }

  const handleResend = async () => {
    setResendLoading(true)
    setError('')
    try {
      await axiosInstance.post(API.sendOtp, {
        phoneNumber: phone,
        type: 'FORGOT_MPIN',
      })
      setEmailOtp(['', '', '', '', '', ''])
      setPhoneOtp(['', '', '', '', '', ''])
    } catch {
      setError('Failed to resend OTP.')
    } finally {
      setResendLoading(false)
    }
  }

  const filled =
    emailOtp.join('').length === 6 &&
    phoneOtp.join('').length === 6 &&
    mpin.join('').length === 4 &&
    confirmMpin.join('').length === 4

  return (
    <div className="slide-in">
      {/* <BackButton onClick={onBack} disabled={loading} label="Back to Login" /> */}

      <p style={{ ...s.subtitle, marginBottom: '20px' }}>
        An OTP has been sent to{' '}
        <strong style={{ color: '#3B3D1A' }}>{emailId}</strong>{' '}
        &amp; <strong style={{ color: '#3B3D1A' }}>+91 {phone}</strong>
      </p>

      <div style={{ marginBottom: '4px' }}>
        <p style={s.sectionLabel}>Enter Email OTP</p>
        <OtpInputRow value={emailOtp} onChange={setEmailOtp} disabled={loading} error={!!error} />
      </div>

      <div style={{ marginBottom: '16px' }}>
        <p style={s.sectionLabel}>Enter Phone OTP</p>
        <OtpInputRow value={phoneOtp} onChange={setPhoneOtp} disabled={loading} error={!!error} />
      </div>

      <ResendTimer onResend={handleResend} loading={resendLoading} />

      <div style={{ marginBottom: '4px' }}>
        <p style={s.sectionLabel}>Enter New MPIN</p>
        <MpinInputRow value={mpin} onChange={setMpin} disabled={loading} error={!!error} />
      </div>

      <div style={{ marginBottom: '16px' }}>
        <p style={s.sectionLabel}>Confirm New MPIN</p>
        <MpinInputRow
          value={confirmMpin}
          onChange={setConfirmMpin}
          disabled={loading}
          error={!!error && mpin.join('') !== confirmMpin.join('')}
        />
      </div>

      {error && <div style={s.errorBox}>{error}</div>}

      <button
        style={{ ...s.btn, ...(!filled || loading ? s.btnDisabled : {}) }}
        onClick={handleReset}
        disabled={!filled || loading}
      >
        {loading ? <><Spinner /> Resetting…</> : <>Reset MPIN <ArrowIcon /></>}
      </button>
    </div>
  )
}

// ── SUCCESS STEPS (3 variants) ────────────────────────────────

// Variant 1: Login success — warm welcome back
const LoginSuccessStep = () => (
  <div className="slide-in" style={{ textAlign: 'center', padding: '8px 0' }}>
    <div
      className="pop-in"
      style={{
        width: '72px', height: '72px',
        background: 'linear-gradient(135deg, #6B6F2A, #B5BC4A)',
        borderRadius: '50%',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        margin: '0 auto 20px',
        boxShadow: '0 8px 28px rgba(107,111,42,0.40)',
      }}
    >
      <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
        stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
      </svg>
    </div>
    <h2 className="fade-up-1" style={{ ...s.h1, fontSize: '1.6rem', marginBottom: '8px' }}>
      Welcome Back!
    </h2>
    <p className="fade-up-2" style={{ ...s.subtitle, marginBottom: '20px' }}>
      You've logged in successfully.<br />Taking you to your dashboard…
    </p>
    <div className="fade-up-3" style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '8px',
      background: '#EEF4DC',
      border: '1px solid #B5BC4A',
      borderRadius: '20px',
      padding: '8px 18px',
      fontSize: '0.82rem',
      color: '#6B6F2A',
      fontWeight: '600',
    }}>
      <svg width="14" height="14" viewBox="0 0 24 24" fill="#6B6F2A">
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z" />
      </svg>
      Redirecting…
    </div>
  </div>
)

// Variant 2: MPIN Setup success — account activated feel
const SetupMpinSuccessStep = () => (
  <div className="slide-in" style={{ textAlign: 'center', padding: '8px 0' }}>
    <div
      className="pop-in"
      style={{
        width: '72px', height: '72px',
        background: 'linear-gradient(135deg, #2A6F4A, #4ABC7A)',
        borderRadius: '18px',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        margin: '0 auto 20px',
        boxShadow: '0 8px 28px rgba(42,111,74,0.40)',
      }}
    >
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none"
        stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
    </div>
    <h2 className="fade-up-1" style={{ ...s.h1, fontSize: '1.5rem', marginBottom: '8px', color: '#1A3D2A' }}>
      MPIN Set Successfully!
    </h2>
    <p className="fade-up-2" style={{ ...s.subtitle, marginBottom: '20px' }}>
      Your account is now secured with a PIN.<br />Taking you back to log in…
    </p>
    <div className="fade-up-3" style={{
      background: '#EDFAF3',
      border: '1px solid #4ABC7A',
      borderRadius: '12px',
      padding: '12px 16px',
      fontSize: '0.83rem',
      color: '#1A3D2A',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '8px',
    }}>
      <svg width="15" height="15" viewBox="0 0 24 24" fill="#2A6F4A" style={{ flexShrink: 0 }}>
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
      </svg>
      Returning to login…
    </div>
  </div>
)

// Variant 3: Forgot MPIN reset success — reassurance feel
const ForgotMpinSuccessStep = () => (
  <div className="slide-in" style={{ textAlign: 'center', padding: '8px 0' }}>
    <div
      className="pop-in"
      style={{
        width: '72px', height: '72px',
        background: 'linear-gradient(135deg, #4A6F2A, #A4BC4A)',
        borderRadius: '50%',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        margin: '0 auto 20px',
        boxShadow: '0 8px 28px rgba(74,111,42,0.40)',
        position: 'relative',
      }}
    >
      {/* Shield + checkmark */}
      <svg width="34" height="34" viewBox="0 0 24 24" fill="none"
        stroke="white" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <polyline points="9 12 11 14 15 10" />
      </svg>
    </div>
    <h2 className="fade-up-1" style={{ ...s.h1, fontSize: '1.5rem', marginBottom: '8px' }}>
      MPIN Reset Done!
    </h2>
    <p className="fade-up-2" style={{ ...s.subtitle, marginBottom: '20px' }}>
      Your MPIN has been updated successfully.<br />Use your new PIN on your next login.
    </p>
    <div className="fade-up-3" style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '8px',
      background: '#F5F4E8',
      border: '1px solid #E8ECBF',
      borderRadius: '12px',
      padding: '14px 16px',
      fontSize: '0.82rem',
      color: '#6B6F2A',
      fontWeight: '500',
      textAlign: 'left',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="#6B6F2A"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
        New MPIN saved securely
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="#6B6F2A"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" /></svg>
        Returning to login…
      </div>
    </div>
  </div>
)

// ── HELPERS ───────────────────────────────────────────────────
const persistAuth = (data) => {
  if (data?.token) localStorage.setItem('token', data.token)
  if (data?.userData) localStorage.setItem('userData', JSON.stringify(data.userData))
  if (data?.enterprises) localStorage.setItem('enterpriseData', JSON.stringify(data.enterprises))
}

// ── STEP META ─────────────────────────────────────────────────
const STEP_META = {
  phone:           { title: 'Welcome',          subtitle: 'with a valid number, you can access deliveries, and our other services' },
  mpinLogin:       { title: 'Welcome',           subtitle: '' },
  otpLogin:        { title: 'OTP Verification',  subtitle: '' },
  setMpin:         { title: 'Set your MPIN',     subtitle: '' },
  forgotMpin:      { title: 'Reset your MPIN',   subtitle: '' },
  successLogin:    { title: '',                  subtitle: '' },
  successSetMpin:  { title: '',                  subtitle: '' },
  successForgot:   { title: '',                  subtitle: '' },
}

// ── MAIN ──────────────────────────────────────────────────────
const Login = () => {
  // step: 'phone' | 'mpinLogin' | 'otpLogin' | 'setMpin' | 'forgotMpin'
  //     | 'successLogin' | 'successSetMpin' | 'successForgot'
  const [step, setStep] = useState('phone')
  const [accountInfo, setAccountInfo] = useState(null)

  const meta = STEP_META[step]

  const handleAccountChecked = async (info) => {
    setAccountInfo(info)
    if (info.isMPINSetupRequired) {
      try {
        await axiosInstance.post(API.sendOtp, {
          phoneNumber: info.phone,
          type: 'SETUP_MPIN',
        })
      } catch (e) {
        // proceed anyway; SetMpinStep has its own resend
      }
      setStep('setMpin')
    } else {
      setStep('mpinLogin')
    }
  }

  // successType: 'login' | 'setupMpin' | 'forgotMpin'
  const handleSuccess = (data, successType) => {
    if (successType === 'setupMpin') {
      setStep('successSetMpin')
      toast.success('MPIN set up successfully!')
      // After setup, go back to login so user can log in with their new MPIN
      setTimeout(() => setStep('mpinLogin'), 2500)
    } else if (successType === 'forgotMpin') {
      setStep('successForgot')
      toast.success('MPIN reset successfully!')
      // After reset, go back to login so user can log in with their new MPIN
      setTimeout(() => setStep('mpinLogin'), 2500)
    } else {
      // Only actual login goes to dashboard
      setStep('successLogin')
      toast.success('Login successful')
      setTimeout(() => { window.location.href = '/dashboard' }, 2000)
    }
  }

  const isSuccess = step.startsWith('success')

  // Step indicator: phone(0), login/setup(1), success(2)
  const stepIndex = {
    phone: 0,
    mpinLogin: 1, otpLogin: 1, setMpin: 1, forgotMpin: 1,
    successLogin: 2, successSetMpin: 2, successForgot: 2,
  }[step]
  const totalSteps = 2

  return (
    <div style={s.body}>
      <style>{globalCSS}</style>
      <Navbar />

      <main style={s.main}>
        <div style={s.card}>
          <div style={s.topBar} />

          <div className="nav-brand" style={{ marginBottom: '20px' }}>
            <img src="images/imt2.png" alt="imTransporter" />
          </div>

          {!isSuccess && (
            <div style={s.stepIndicator}>
              {Array.from({ length: totalSteps }, (_, i) => (
                <div key={i} style={{
                  ...s.stepDot,
                  ...(i === stepIndex ? s.stepDotActive : {}),
                  ...(i < stepIndex ? s.stepDotDone : {}),
                }} />
              ))}
            </div>
          )}

          {meta.title && <h1 style={s.h1}>{meta.title}</h1>}
          {meta.subtitle && <p style={s.subtitle}>{meta.subtitle}</p>}

          {step === 'phone' && (
            <PhoneStep onAccountChecked={handleAccountChecked} />
          )}

          {step === 'mpinLogin' && (
            <MpinLoginStep
              phone={accountInfo.phone}
              onSuccess={handleSuccess}
              onBack={() => setStep('phone')}
              onSwitchToOtp={() => setStep('otpLogin')}
              onForgotMpin={() => setStep('forgotMpin')}
            />
          )}

          {step === 'otpLogin' && (
            <OtpLoginStep
              phone={accountInfo.phone}
              emailId={accountInfo.emailId}
              onSuccess={handleSuccess}
              onBack={() => setStep('mpinLogin')}
            />
          )}

          {step === 'setMpin' && (
            <SetMpinStep
              phone={accountInfo.phone}
              emailId={accountInfo.emailId}
              onSuccess={handleSuccess}
              onBack={() => setStep('phone')}
            />
          )}

          {step === 'forgotMpin' && (
            <ForgotMpinStep
              phone={accountInfo.phone}
              emailId={accountInfo.emailId}
              onSuccess={handleSuccess}
              onBack={() => setStep('mpinLogin')}
            />
          )}

          {step === 'successLogin'   && <LoginSuccessStep />}
          {step === 'successSetMpin' && <SetupMpinSuccessStep />}
          {step === 'successForgot'  && <ForgotMpinSuccessStep />}

          {step === 'phone' && (
            <p style={s.footer}>
              By continuing, you agree to our{' '}
              <a href="#" style={s.link}>Terms</a> &amp;{' '}
              <a href="#" style={s.link}>Privacy Policy</a>
            </p>
          )}
        </div>
      </main>
    </div>
  )
}

export default Login